import { FirebaseError } from 'firebase/app'

// Firestore listeners outlive the Firebase user they were opened for: when the Pilote session is lost
// (user becomes null) or another Pilote account signs in on the same browser (user A becomes user B),
// Firestore reopens every listener with the new credentials, and the rules refuse them — users/A only
// lets A read it. The provider signs back in and the listeners follow the new user; the refusal says
// nothing about the rules. A refusal while a user stays signed in is a real one and still goes out.
const SETTLE_MILLIS = 10_000

export const createAuthTransitionTracker = (now: () => number = Date.now) => {
  let currentUid: string | null | undefined
  let leftUserAt = Number.NEGATIVE_INFINITY

  return {
    noteAuthUser: (uid: string | null) => {
      if (currentUid && uid !== currentUid) {
        leftUserAt = now()
      }
      currentUid = uid
    },
    isAuthTransitionRefusal: (error: unknown) =>
      error instanceof FirebaseError &&
      error.code === 'permission-denied' &&
      (currentUid === null || now() - leftUserAt < SETTLE_MILLIS),
  }
}

export const authTransitions = createAuthTransitionTracker()
